export default "__VITE_ASSET__dc2ee3aa__"